import { motion, useScroll, useTransform } from "framer-motion";
import { ArrowDown } from "lucide-react";
import { IMAGES } from "../data/content";
import { MaskedLine } from "../components/Reveal";
import { scrollToTarget } from "../lib/scroll";

const Hero = () => {
  const { scrollY } = useScroll();
  const y = useTransform(scrollY, [0, 900], [0, 220]);
  const opacity = useTransform(scrollY, [0, 600], [1, 0.25]);

  return (
    <section id="inicio" data-testid="rnb-hero-section" className="relative min-h-[100svh] flex items-end overflow-hidden">
      <motion.div style={{ y }} className="absolute inset-0">
        <img
          src={IMAGES.hero}
          alt="Dani Postigo en tarima, culturista profesional natural"
          className="h-[110%] w-full object-cover object-[65%_12%]"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/45 to-black/15" aria-hidden="true" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-transparent to-[#050505]" />
      </motion.div>

      <motion.div style={{ opacity }} className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full pb-24 pt-40">
        <MaskedLine delay={0.15}>
          <span className="inline-block border border-zinc-600 text-zinc-300 text-[10px] sm:text-xs tracking-[0.35em] px-4 py-2 uppercase">
            Culturismo profesional natural · Co-fundador OCB Spain
          </span>
        </MaskedLine>
        <h1 className="mt-6 font-display text-rough text-white leading-[0.9] text-6xl sm:text-8xl lg:text-[9rem]">
          <MaskedLine delay={0.3}>TU MEJOR FÍSICO,</MaskedLine>
          <MaskedLine delay={0.45}>
            <span className="text-transparent" style={{ WebkitTextStroke: "2px #fff" }}>
              DE FORMA NATURAL
            </span>
          </MaskedLine>
        </h1>
        <MaskedLine delay={0.65} className="mt-6 max-w-xl">
          <span className="block text-base sm:text-lg text-zinc-300 font-light leading-relaxed">
            Sin improvisar, sin vivir para el gimnasio y sin recurrir a atajos.
          </span>
        </MaskedLine>
        <MaskedLine delay={0.8} className="mt-2 max-w-xl">
          <span className="block text-sm sm:text-base text-zinc-500 italic">
            Porque tu cuerpo es tu proyecto más importante.
          </span>
        </MaskedLine>
        <MaskedLine delay={0.95} className="mt-10">
          <button
            onClick={() => scrollToTarget("#coaching-vip")}
            data-testid="rnb-hero-cta-cambia-tu-vida"
            className="group inline-flex items-center gap-3 bg-white text-black font-display text-xl sm:text-2xl tracking-[0.15em] px-8 sm:px-10 py-4 hover:bg-zinc-200 transition-colors"
          >
            CAMBIA TU VIDA
            <ArrowDown className="h-5 w-5 transition-transform duration-300 group-hover:translate-y-1" />
          </button>
        </MaskedLine>
      </motion.div>
    </section>
  );
};

export default Hero;
